import { inject, observer } from 'mobx-react'
import * as R from 'ramda'
import React from 'react'
import { translate } from 'react-i18next'
import { NavLink } from 'react-router-dom'
import { handleClick } from '../../helpers'

import { getGenderUrl } from 'helpers/gender'
import LayoutStore from 'store/features/layout'
import UserStore from 'store/features/user'

import LocaleStore from 'store/features/locale'
import styled from 'styled-components'
import { outline } from 'uiComponents/constants/colors'
import { fsS, fwBold } from 'uiComponents/constants/typography'

interface IProps {
  t?: any
  userStore: UserStore
  localeStore: LocaleStore
  layoutStore: LayoutStore
}

const StyledNavLink = styled(NavLink)`
  position: relative;
  margin: 0 0 0 21px;
  display: inline-block;
  font-size: ${fsS}px;
  direction: initial;

  &::before {
    content: '';
    width: 1px;
    height: 16px;
    background-color: ${outline};
    position: absolute;
    left: -11px;
    top: 50%;
    margin: -8px 0 0;
  }

  &:first-child {
    margin: 0;

    &::before {
      display: none;
    }
  }

  .linkActive {
    ${fwBold}
  }
`

const Filters = ({ t, userStore, localeStore, layoutStore }: IProps) => {
  const baseUrl = `/${getGenderUrl(localeStore.locale)(
    userStore.gender,
  )}/outfits`
  const newOutfitsUrl = `${baseUrl}/${t('neue-outfits_url')}`

  return (
    <nav>
      <StyledNavLink
        to={baseUrl}
        onClick={() => handleClick(layoutStore)}
        activeClassName={'linkActive'}
      >
        {t('Alle Outfits')}
      </StyledNavLink>
      <StyledNavLink
        to={newOutfitsUrl}
        onClick={() => handleClick(layoutStore)}
        activeClassName={'linkActive'}
      >
        {t('Neu')}
      </StyledNavLink>
    </nav>
  )
}

export default R.compose(
  translate(),
  inject('userStore', 'localeStore', 'layoutStore'),
  observer,
)(Filters)
